/*
 * THE FLYING BEANS — ABOUT US PAGE JAVASCRIPT
 * Architecture: Isolated GSAP ScrollTrigger Animations, Lifecycle Management, Reduced Motion Support
 */

(function() {
  'use strict';

  function initAboutAnimations() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    if (typeof gsap === 'undefined') {
      return;
    }

    if (typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    }

    // 01 — Hero Animation
    const hero = document.querySelector('.tfb-about-hero');
    if (hero) {
      const heroTl = gsap.timeline({
        defaults: { ease: 'power2.out', duration: 0.8 }
      });

      const heroLeft = hero.querySelectorAll('.tfb-about-eyebrow, .tfb-about-hero__title, .tfb-about-hero__desc, .tfb-about-hero__script');
      const heroImg = hero.querySelector('.tfb-about-hero__media');

      if (heroLeft.length) {
        heroTl.from(heroLeft, {
          opacity: 0,
          y: 20,
          stagger: 0.12
        });
      }

      if (heroImg) {
        heroTl.from(heroImg, {
          opacity: 0,
          scale: 0.98,
          duration: 1
        }, '-=0.6');
      }
    }

    // Scroll-triggered reveals for subsequent sections
    if (typeof ScrollTrigger === 'undefined') return;

    // 02 — Purpose Pillars Reveal
    const purpose = document.querySelector('.tfb-about-purpose');
    if (purpose) {
      const pillars = purpose.querySelectorAll('.tfb-about-pillar');
      if (pillars.length) {
        gsap.from(pillars, {
          scrollTrigger: {
            trigger: purpose,
            start: 'top 80%',
            toggleActions: 'play none none none'
          },
          opacity: 0,
          y: 24,
          stagger: 0.1,
          duration: 0.7,
          ease: 'power2.out'
        });
      }
    }

    // 03 — Approach Split Reveal
    const approach = document.querySelector('.tfb-about-approach');
    if (approach) {
      const approachMedia = approach.querySelector('.tfb-about-approach__media');
      const approachText = approach.querySelector('.tfb-about-approach__text-col');

      if (approachMedia && approachText) {
        gsap.from([approachMedia, approachText], {
          scrollTrigger: {
            trigger: approach,
            start: 'top 80%',
            toggleActions: 'play none none none'
          },
          opacity: 0,
          y: 25,
          stagger: 0.15,
          duration: 0.8,
          ease: 'power2.out'
        });
      }
    }

    // 04 — Four Origins Reveal
    const origins = document.querySelector('.tfb-about-origins');
    if (origins) {
      const originCards = origins.querySelectorAll('.tfb-about-origin-card');
      if (originCards.length) {
        gsap.from(originCards, {
          scrollTrigger: {
            trigger: origins,
            start: 'top 80%',
            toggleActions: 'play none none none'
          },
          opacity: 0,
          y: 20,
          stagger: 0.1,
          duration: 0.7,
          ease: 'power2.out'
        });
      }
    }

    // 05 — Commitment Reveal
    const commitment = document.querySelector('.tfb-about-commitment');
    if (commitment) {
      const commitContent = commitment.querySelector('.tfb-about-commitment__content');
      if (commitContent) {
        gsap.from(commitContent, {
          scrollTrigger: {
            trigger: commitment,
            start: 'top 85%',
            toggleActions: 'play none none none'
          },
          opacity: 0,
          y: 20,
          duration: 0.8,
          ease: 'power2.out'
        });
      }
    }

    // 06 — Closing Reveal
    const closing = document.querySelector('.tfb-about-closing');
    if (closing) {
      const closingWrap = closing.querySelector('.tfb-about-closing__wrap');
      if (closingWrap) {
        gsap.from(closingWrap, {
          scrollTrigger: {
            trigger: closing,
            start: 'top 85%',
            toggleActions: 'play none none none'
          },
          opacity: 0,
          y: 20,
          duration: 0.8,
          ease: 'power2.out'
        });
      }
    }
  }

  // Lifecycle Initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAboutAnimations);
  } else {
    initAboutAnimations();
  }

  // Shopify Theme Editor Integration
  document.addEventListener('shopify:section:load', function() {
    initAboutAnimations();
  });
})();
